<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">
      <div class="xblock layui-form">
        <div class="layui-input-inline country_select xblock-row">
          <select name="status" v-model="current_status" lay-verify="required" lay-filter="status_selection">
            <option value="0">全部</option>
            <option :value="item.id" v-text="item.name" v-for="(item,index) in status" v-bind:key="index"></option>
          </select>
        </div>
        <div class="x-right xblock-row">
          <span class="x-right" v-text="'　共有数据：'+count+ '条'"></span>
          <span class="x-right" v-text="'总额：'+total+ '元　|'"></span>
        </div>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table">
        <thead>
          <tr>
            <th>订单号</th>
            <th>金额</th>
            <th>当前余额</th>
            <th>扣费类型</th>
            <th>时间</th>
          </tr>
        </thead>
        <tbody>
          <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
            <td class="order-code" v-text="item.relation_id" v-on:click="SearchOrder(item.relation_id)"></td>
            <td v-text="item.money"></td>
            <td v-text="item.last_money"></td>
            <td>
              <i v-if="item.log_type == 'package'">打包费用</i>
              <i v-else-if="item.log_type == 'return'">商品退货</i>
              <i v-else-if="item.log_type == 'check'">快递检测</i>
              <i v-else>其他</i>
            </td>

            <td v-text="item.created_at"></td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>
    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'ConsumptionRecord',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        isLoding: false,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        page_num: 20,
        current_status: 0,
        status_id: 0,
        list: [],
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "打包"
        }]
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("货代", self.$route.name);

      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        form.on('select(status_selection)', function(data) {
          var val = $("select[name=status").val() - 1;
          self.current_status = val;
          var status;
          if (val != -1) {
            status = self.status[self.current_status].id;
          } else {
            status = 0;
          }
          self.status_id = status; //获取当前站点
          self.get_consumption_record(true)
        });
        form.render('select');

        self.get_consumption_record()
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_consumption_record() {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/consumption_record/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            console.log(datas)
            if (datas.page) {
              self.list = datas.list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "get_consumption_record"); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      SearchOrder(oid) {
        window.open(self.PromoteUrl() + "/#/Order?te=0&id=" + oid);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .order-code:hover {
    cursor: pointer;
    color: #42b8f1;
  }
</style>



// WEBPACK FOOTER //
// src/components/logistics/ConsumptionRecord.vue